module.exports = __webpack_public_path__ + "static/media/mark-present-with-exception.eb3dcb8b.svg";